import { IHttpService, IPromise } from "angular";

interface IGifMedia {
  dims: [number, number];
  size: number;
  url: string;
}

export const tenorApiKey = "8S423V0QMWIB";

export enum SizeOfGif {
  Small = "nanogif",
  Medium = "tinygif",
  Big = "gif",
}
interface ITenorResponse {
  results: IGifResponse[];
}
interface IGifResponse {
  id: string;
  media: IGifMedia;
}
export type GifType = "trending" | "search" | "gifs";
export type GifSize = `${SizeOfGif}`;
export type GifDataParams = { gifType: GifType; gifSize: GifSize; searchQuery?: string; gifId?: string };
export class TenorGifService {
  public static $inject = ["$http"];

  constructor(private $http: IHttpService) {}

  public getGifData(params: GifDataParams): IPromise<IGifResponse[]> {
    let url = `https://g.tenor.com/v1/${params.gifType}?key=${tenorApiKey}&media_filter=${params.gifSize}&limit=8`;
    if (params.searchQuery) {
      url += `&q=${params.searchQuery}`;
    }
    if (params.gifId) {
      url += `&ids=${params.gifId}`;
    }

    return this.$http.get<ITenorResponse>(url).then((response) =>
      response.data.results.map((obj) => {
        return {
          id: obj.id,
          media: obj.media[0]?.[params.gifSize],
        };
      })
    );
  }
}
